import React from 'react';
import PropTypes from 'prop-types';
import Tooltip from '../Tooltips/Tooltip';
import Button from '../Buttons/Button';
import Icon from '../Icons/Icon';
import HorizontalScroll from '../Containers/HorizontalScroll';

const FreeFormButtons = ({ addInput }) => {
  const btnClass = `btn--icon btn--tertiary`;
  const iconSize = `m`;
  const iconFill = `black`;

  return (
    <div className="freeform-btns">
      <p className="text-grey">Click to add either a title, paragraph, bullet point list, ordered list, dropdown, image or embed code</p>

      <ul className="inline-list">
        <li>
          <Tooltip text="Add Heading">
            <Button onClick={e => addInput(e, `heading`)} classes={btnClass}>
              <Icon name="heading" size={iconSize} fill={iconFill} />
              <span className="sr-only">Add Heading</span>
            </Button>
          </Tooltip>
        </li>

        <li>
          <Tooltip text="Add Paragraph">
            <Button onClick={e => addInput(e, `text`)} classes={btnClass}>
              <Icon name="text" size={iconSize} fill={iconFill} />
              <span className="sr-only">Add Paragraph</span>
            </Button>
          </Tooltip>
        </li>

        <li>
          <Tooltip text="Add Bullet List">
            <Button onClick={e => addInput(e, `bullet_list`)} classes={btnClass}>
              <Icon name="bullet-list" size={iconSize} fill={iconFill} />
              <span className="sr-only">Add Bullet List</span>
            </Button>
          </Tooltip>
        </li>

        <li>
          <Tooltip text="Add Numbered List">
            <Button onClick={e => addInput(e, `number_list`)} classes={btnClass}>
              <Icon name="numbered-list" size={iconSize} fill={iconFill} />
              <span className="sr-only">Add Numbered List</span>
            </Button>
          </Tooltip>
        </li>

        <li>
          <Tooltip text="Add Dropdown">
            <Button onClick={e => addInput(e, `accordion`)} classes={btnClass}>
              <Icon name="accordion" size={iconSize} fill={iconFill} />
              <span className="sr-only">Add Dropdown</span>
            </Button>
          </Tooltip>
        </li>

        <li>
          <Tooltip text="Add Image/Diagram">
            <Button onClick={e => addInput(e, `image`)} classes={btnClass}>
              <Icon name="outline-add-image" size={iconSize} fill={iconFill} />
              <span className="sr-only">Add Image/Diagram</span>
            </Button>
          </Tooltip>
        </li>

        <li>
          <Tooltip text="Embed Video">
            <Button onClick={e => addInput(e, `bespoke_stream`)} classes={btnClass}>
              <Icon name="outline-play-circle" size={iconSize} fill={iconFill} />
              <span className="sr-only">Embed Video</span>
            </Button>
          </Tooltip>
        </li>
      </ul>
    </div>
  );
};

FreeFormButtons.propTypes = {
  addInput: PropTypes.func,
};

export default FreeFormButtons;



// WEBPACK FOOTER //
// ./library/app/components/Global/Forms/FreeFormButtons.js